/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetConsultationDto
 */
export interface GetConsultationDto {
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    number?: string | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetConsultationDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetConsultationDto
     */
    consultDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    type?: GetConsultationDtoTypeEnum | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetConsultationDto
     */
    author?: GetUserDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsultationDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    descriptionExam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    interview?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    recommendations?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    pdfTemplateType?: GetConsultationDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    recognition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    contraindications?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityDistanceOd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityDistanceOs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityNearNod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityNearNos?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    pseudoisochromaticPlates?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    slitLamp?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsultationDto
     */
    spatialVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsultationDto
     */
    fieldOfVisionRight?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsultationDto
     */
    fieldOfVisionLeft?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    eyeAlignment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    alternateCover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    convergence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityWithCorrectionOd?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    acuityWithCorrectionOs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    protectiveDeviceConjunctiva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    protectiveDeviceEyelids?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    anteriorSegment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    fundusOfEye?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    otoscopyRight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    otoscopyLeft?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    throatAndLarynx?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    inflammatoryChanges?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    audiologicalDistance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    audiologicalRight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConsultationDto
     */
    audiologicalLeft?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsultationDto
     */
    romberg?: boolean | null;
}


/**
 * @export
 */
export const GetConsultationDtoTypeEnum = {
    Neurological: 'Neurological',
    Ophthalmologist: 'Ophthalmologist',
    ENT: 'ENT',
    Psychiatric: 'Psychiatric'
} as const;
export type GetConsultationDtoTypeEnum = typeof GetConsultationDtoTypeEnum[keyof typeof GetConsultationDtoTypeEnum];

/**
 * @export
 */
export const GetConsultationDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type GetConsultationDtoPdfTemplateTypeEnum = typeof GetConsultationDtoPdfTemplateTypeEnum[keyof typeof GetConsultationDtoPdfTemplateTypeEnum];


/**
 * Check if a given object implements the GetConsultationDto interface.
 */
export function instanceOfGetConsultationDto(value: object): value is GetConsultationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetConsultationDtoFromJSON(json: any): GetConsultationDto {
    return GetConsultationDtoFromJSONTyped(json, false);
}

export function GetConsultationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConsultationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'consultDate': json['consultDate'] == null ? undefined : (new Date(json['consultDate'])),
        'type': json['type'] == null ? undefined : json['type'],
        'author': json['author'] == null ? undefined : GetUserDtoFromJSON(json['author']),
        'pass': json['pass'] == null ? undefined : json['pass'],
        'descriptionExam': json['descriptionExam'] == null ? undefined : json['descriptionExam'],
        'interview': json['interview'] == null ? undefined : json['interview'],
        'recommendations': json['recommendations'] == null ? undefined : json['recommendations'],
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'recognition': json['recognition'] == null ? undefined : json['recognition'],
        'contraindications': json['contraindications'] == null ? undefined : json['contraindications'],
        'acuityDistanceOd': json['acuityDistanceOd'] == null ? undefined : json['acuityDistanceOd'],
        'acuityDistanceOs': json['acuityDistanceOs'] == null ? undefined : json['acuityDistanceOs'],
        'acuityNearNod': json['acuityNearNod'] == null ? undefined : json['acuityNearNod'],
        'acuityNearNos': json['acuityNearNos'] == null ? undefined : json['acuityNearNos'],
        'pseudoisochromaticPlates': json['pseudoisochromaticPlates'] == null ? undefined : json['pseudoisochromaticPlates'],
        'slitLamp': json['slitLamp'] == null ? undefined : json['slitLamp'],
        'spatialVision': json['spatialVision'] == null ? undefined : json['spatialVision'],
        'fieldOfVisionRight': json['fieldOfVisionRight'] == null ? undefined : json['fieldOfVisionRight'],
        'fieldOfVisionLeft': json['fieldOfVisionLeft'] == null ? undefined : json['fieldOfVisionLeft'],
        'eyeAlignment': json['eyeAlignment'] == null ? undefined : json['eyeAlignment'],
        'alternateCover': json['alternateCover'] == null ? undefined : json['alternateCover'],
        'convergence': json['convergence'] == null ? undefined : json['convergence'],
        'acuityWithCorrectionOd': json['acuityWithCorrectionOd'] == null ? undefined : json['acuityWithCorrectionOd'],
        'acuityWithCorrectionOs': json['acuityWithCorrectionOs'] == null ? undefined : json['acuityWithCorrectionOs'],
        'protectiveDeviceConjunctiva': json['protectiveDeviceConjunctiva'] == null ? undefined : json['protectiveDeviceConjunctiva'],
        'protectiveDeviceEyelids': json['protectiveDeviceEyelids'] == null ? undefined : json['protectiveDeviceEyelids'],
        'anteriorSegment': json['anteriorSegment'] == null ? undefined : json['anteriorSegment'],
        'fundusOfEye': json['fundusOfEye'] == null ? undefined : json['fundusOfEye'],
        'otoscopyRight': json['otoscopyRight'] == null ? undefined : json['otoscopyRight'],
        'otoscopyLeft': json['otoscopyLeft'] == null ? undefined : json['otoscopyLeft'],
        'throatAndLarynx': json['throatAndLarynx'] == null ? undefined : json['throatAndLarynx'],
        'inflammatoryChanges': json['inflammatoryChanges'] == null ? undefined : json['inflammatoryChanges'],
        'audiologicalDistance': json['audiologicalDistance'] == null ? undefined : json['audiologicalDistance'],
        'audiologicalRight': json['audiologicalRight'] == null ? undefined : json['audiologicalRight'],
        'audiologicalLeft': json['audiologicalLeft'] == null ? undefined : json['audiologicalLeft'],
        'romberg': json['romberg'] == null ? undefined : json['romberg'],
    };
}

export function GetConsultationDtoToJSON(value?: GetConsultationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'exam': GetExamDtoToJSON(value['exam']),
        'consultDate': value['consultDate'] == null ? undefined : ((value['consultDate'] as any).toISOString()),
        'type': value['type'],
        'author': GetUserDtoToJSON(value['author']),
        'pass': value['pass'],
        'descriptionExam': value['descriptionExam'],
        'interview': value['interview'],
        'recommendations': value['recommendations'],
        'pdfTemplateType': value['pdfTemplateType'],
        'recognition': value['recognition'],
        'contraindications': value['contraindications'],
        'acuityDistanceOd': value['acuityDistanceOd'],
        'acuityDistanceOs': value['acuityDistanceOs'],
        'acuityNearNod': value['acuityNearNod'],
        'acuityNearNos': value['acuityNearNos'],
        'pseudoisochromaticPlates': value['pseudoisochromaticPlates'],
        'slitLamp': value['slitLamp'],
        'spatialVision': value['spatialVision'],
        'fieldOfVisionRight': value['fieldOfVisionRight'],
        'fieldOfVisionLeft': value['fieldOfVisionLeft'],
        'eyeAlignment': value['eyeAlignment'],
        'alternateCover': value['alternateCover'],
        'convergence': value['convergence'],
        'acuityWithCorrectionOd': value['acuityWithCorrectionOd'],
        'acuityWithCorrectionOs': value['acuityWithCorrectionOs'],
        'protectiveDeviceConjunctiva': value['protectiveDeviceConjunctiva'],
        'protectiveDeviceEyelids': value['protectiveDeviceEyelids'],
        'anteriorSegment': value['anteriorSegment'],
        'fundusOfEye': value['fundusOfEye'],
        'otoscopyRight': value['otoscopyRight'],
        'otoscopyLeft': value['otoscopyLeft'],
        'throatAndLarynx': value['throatAndLarynx'],
        'inflammatoryChanges': value['inflammatoryChanges'],
        'audiologicalDistance': value['audiologicalDistance'],
        'audiologicalRight': value['audiologicalRight'],
        'audiologicalLeft': value['audiologicalLeft'],
        'romberg': value['romberg'],
    };
}

